<template>
    <div class="o-dashboard c-chat__wrapper">
        <c-loader-container :loading="loading">

            <template v-if="!loading">
                <div class="o-dashboard__breadcrumbs">
                    <c-breadcrumbs></c-breadcrumbs>
                </div>

                <div class="c-chat__header">
                    <h2 class="margin-b-8">{{ user.is_planner ? chatter : 'Planner'}}</h2>
                    <div class="margin-b-24">Heb je vragen of opmerkingen over je opdracht? Stel ze in deze chat.</div>
                </div>

                <div class="c-chat">
                    <c-placeholder v-if="messages.length == 0"></c-placeholder>
                    <c-message v-for="(message,index) in messages" :message="message" :key="index"></c-message>
                </div>
                <c-form class="c-chat__message-bar" @valid="submit">
                    <div class="c-chat__message-send">
                        <div class="c-form-element">
                            <div class="c-form-element__input">
                                <textarea placeholder="Je bericht" name="message" v-model="draft"></textarea>
                            </div>
                        </div>
                        <button type="submit" class="c-btn c-btn--secondary no-margin">
                            <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="m15 17.8379-1.856-5.567 5.568-5.569L15 17.8379Zm2.298-12.55-5.568 5.568-5.568-1.856 11.136-3.712Zm4.692-2.34a.9513.9513 0 0 0-.053-.27.775.775 0 0 0-.035-.091c-.048-.107-.109-.208-.195-.294-.086-.086-.187-.147-.295-.195a.6852.6852 0 0 0-.089-.035.9867.9867 0 0 0-.275-.054c-.022-.001-.042-.006-.065-.006-.1.002-.201.016-.299.048l-18 6a1 1 0 0 0-.684.949c0 .431.275.813.684.949l8.525 2.842 2.843 8.526c.136.408.517.683.948.683.431 0 .812-.275.948-.683l6-18c.032-.099.047-.199.0481-.299.0009-.024-.0051-.046-.0061-.07Z" id="paperplane"/></defs><use fill="currentColor" fill-rule="nonzero" xlink:href="#paperplane"/></svg>
                        </button>
                    </div>
                </c-form>
            </template>
        </c-loader-container>
    </div>
</template>



<script>
import CMessage from '@components/chat/Message';
import CPlaceholder from '@components/chat/Placeholder';
import CForm from '@components/form/Container';
import CLoaderContainer from '@components/loader/Container';
import CBreadcrumbs from '@components/Breadcrumbs';
import { mapState } from 'vuex';

export default {
    components: { CForm, CPlaceholder, CMessage, CLoaderContainer, CBreadcrumbs},
    data() {
        return {
            draft: '',
            loading: true,
        }
    },
    methods: {
        submit() {
            if ( this.draft.trim() !== '' ) {
                let params = {
                    id: this.$route.params.id,
                    text: this.draft
                };

                if ( !isNaN(this.$route.query.assigment) ) {
                    params.assignment = this.$route.query.assigment;
                }

                this.$store.dispatch('request/addMessage', params).then(() => {
                    this.draft = '';

                    window.scroll({
                        top: 1000,
                        behavior: 'smooth'
                    });

                }).catch( () => {
                    this.$store.dispatch('toasts/alert', {title: 'Foutmelding', text: 'Het bericht kan niet worden verzonden'});
                });
            }
        }
    },
    computed: {
        ...mapState({
            messages: state => state.request.messages,
            chatter: state => state.request.chatter,
            request: state => state.request.data,
            user: state => state.user.data,
        })
    },
    mounted() {

        let params = {
            id: this.$route.params.id,
        };

        if ( !isNaN(this.$route.query.assigment) ) {
            params.assignment = this.$route.query.assigment;
        }

        this.$store.dispatch('request/messages', params).then(() => {
            this.loading = false

            this.$nextTick( () => {
                window.scroll({
                    top: 1000,
                    behavior: 'smooth'
                });
            });
            this.$store.dispatch('request/markMessagesAsRead', params);
        }).catch( () => {
            this.loading = false;
            this.$store.dispatch('toasts/alert', {title: 'Foutmelding', text: 'De berichten kunnen niet geladen worden'});
        })
    },
    created() {

        if ( this.user.is_planner == 1 && this.$route.query.assigment == undefined ) {
            this.$router.push({ name: 'chat-overview', params: { id: this.$route.params.id } });
        }
    }
}
</script>
